/**
 * Checks to see if the input is a function, and executes and returns the results, if so. If input
 * is not a function, it will simply return the input
 */
export default (fn, ...args) => (typeof fn === 'function' ? fn(...args) : fn);
